/*
 * TPS — Bundle Offer Area <tps-bundle-offer> (main-product bloğu tps_bundle_offer)
 * Fiyatlar kuruş tam sayı (data-price/compare/bundle); kayan nokta toplama yok.
 * Kademeli oran (data-pct3 > 0): seçili sayı 2 → data-pct, 3+ → data-pct3 (ana ürün dahil). Seçili satır güncel
 * kademeyle, seçilmemiş satır "eklenirse" kademesiyle fiyatlanır; satır fiyatları her değişimde yeniden yazılır.
 * Sepet modu (data-cart-discount="true", 2026-10-17): ana ürün de indirime girer; kazanç = uygun seçili satırların
 * TOPLAMI × oran (tek yuvarlama, Shopify gibi), yeni toplam = eski toplam − kazanç. Satır fiyatı yalnız gösterim.
 * Sepete ekleme: tek /cart/add isteği (items[] + _tps_bundle), mini-cart bundled section rendering.
 * Tema bağımlılıkları (global.js / pubsub.js / cart-drawer.js): theme.Currency, fetchConfig,
 * publish + PUB_SUB_EVENTS, <mini-cart>. Hepsi yoksa güvenli yedekle çalışır.
 */
if (!customElements.get('tps-bundle-offer')) {
  class TpsBundleOffer extends HTMLElement {
    /**
     * Seçili satırlardan toplamları hesaplar (kuruş).
     * Satır modu: tasarruf = indirim alan satırlardaki fark. Sepet modu: tasarruf = uygun satır toplamı × oran.
     */
    static calc(rows, pct, cartStyle) {
      let total = 0, old = 0, save = 0, base = 0, count = 0;
      for (const r of rows) {
        if (!r.on) continue;
        count += 1;
        old += r.compare;
        if (r.eligible) base += r.compare;
        total += r.bundle;
        save += r.compare - r.bundle;
      }
      if (cartStyle) {
        save = Math.round((base * pct) / 100);
        total = old - save;
      }
      return { total, old, save, percent: save > 0 ? pct : 0, count };
    }

    /** Seçili ürün sayısına göre oran (%). Kademesiz blokta her zaman data-pct. */
    tierPct(count) {
      if (!this.pct3) return this.pct;
      if (count >= 3) return this.pct3;
      if (count >= 2) return this.pct;
      return 0;
    }

    static money(cents, format) {
      const fmt = format || '{{amount}}';
      if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, fmt);
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, (cents / 100).toFixed(2));
    }

    connectedCallback() {
      if (this.form) return;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-submit]');
      if (!this.form || !this.button) return;
      this.format = (window.theme && theme.shopSettings && theme.shopSettings.moneyFormat) || this.dataset.moneyFormat;
      this.mainAvailable = this.dataset.mainAvailable !== 'false';
      this.pct = parseInt(this.dataset.pct, 10) || 0;
      this.pct3 = parseInt(this.dataset.pct3, 10) || 0;
      this.cartStyle = this.dataset.cartDiscount === 'true';
      this.excludeDiscounted = this.dataset.excludeDiscounted === 'true';
      this.onChange = (e) => {
        if (e.target.matches('.tps-bundle__check')) this.update(true);
      };
      this.onSubmit = (e) => this.submit(e);
      this.onVariant = (e) => {
        const d = e.detail || {};
        if (d.sectionId === this.dataset.sectionId && d.variant) this.setMainVariant(d.variant);
      };
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
      document.addEventListener('variant:change', this.onVariant);
      this.update(false);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariant);
    }

    rows() {
      return [...this.querySelectorAll('[data-row]')].map((el) => ({
        el,
        main: el.hasAttribute('data-main'),
        on: el.querySelector('.tps-bundle__check').checked,
        eligible: !el.hasAttribute('data-ineligible'),
        id: Number(el.dataset.variantId),
        price: parseInt(el.dataset.price, 10) || 0,
        compare: parseInt(el.dataset.compare, 10) || 0,
        bundle: parseInt(el.dataset.bundle, 10) || 0,
      }));
    }

    /** Satır fiyatlarını kademeye göre yeniden yazar; seçili sayıyı ve güncel oranı döner. */
    reprice(rows) {
      const count = rows.filter((r) => r.on).length;
      const now = this.tierPct(count);
      const next = this.tierPct(count + 1);
      for (const r of rows) {
        const discounted = r.eligible && (!r.main || this.cartStyle);
        const pct = discounted ? (r.on ? now : next) : 0;
        r.bundle = Math.round((r.price * (100 - pct)) / 100);
        r.el.dataset.bundle = r.bundle;
        const newEl = r.el.querySelector('[data-new]');
        if (newEl) newEl.textContent = this.fmt(r.bundle);
        const oldEl = r.el.querySelector('[data-old]');
        if (oldEl) oldEl.hidden = !(r.compare > r.bundle);
        const sale = r.el.querySelector('[data-sale-label]');
        if (sale) sale.hidden = !(r.compare > r.bundle);
      }
      return { count, now };
    }

    /** Kademe şeridi + ipucu (yalnız kademeli blok). */
    renderTiers(count) {
      if (!this.pct3) return '';
      this.querySelectorAll('[data-tier]').forEach((li) => {
        const t = Number(li.dataset.tier);
        li.classList.toggle('is-active', t === 3 ? count >= 3 : count === t);
      });
      const d = this.dataset;
      // Seçilebilir ürün < 3 ise 3+ kademesi yok: 2 ürün en yüksek kademedir.
      const reach3 = (parseInt(d.max, 10) || 0) >= 3;
      let hint;
      if (count >= 3) hint = d.tHintMax.replace('[percent]', this.pct3);
      else if (count >= 2 && !reach3) hint = d.tHintMax.replace('[percent]', this.pct);
      else hint = d.tHintNext.replace('[count]', count >= 2 ? 1 : 2 - count).replace('[percent]', count >= 2 ? this.pct3 : this.pct);
      this.text('[data-hint]', hint);
      return hint;
    }

    fmt(cents) {
      return TpsBundleOffer.money(cents, this.format);
    }

    text(sel, value) {
      const el = this.querySelector(sel);
      if (el) el.textContent = value;
      return el;
    }

    update(announce) {
      const rows = this.rows();
      const tier = this.reprice(rows);
      const r = TpsBundleOffer.calc(rows, tier.now, this.cartStyle);
      const hint = this.renderTiers(r.count);
      const d = this.dataset;
      const total = this.fmt(r.total);
      this.text('[data-total-new]', total);
      const oldEl = this.querySelector('[data-total-old]');
      if (oldEl) {
        oldEl.querySelector('[data-money]').textContent = this.fmt(r.old);
        oldEl.hidden = r.old === r.total;
      }
      const badge = this.querySelector('[data-savings]');
      if (badge) {
        badge.hidden = r.save <= 0;
        this.text('[data-savings-amount]', d.tSavings.replace('[amount]', this.fmt(r.save)));
        this.text('[data-savings-percent]', d.tPercent.replace('[percent]', r.percent));
      }
      this.text('[data-count]', d.tCount.replace('[count]', r.count));
      this.count = r.count;
      this.setDisabled(this.busy);
      if (announce) {
        let msg = d.tSummary.replace('[count]', r.count).replace('[total]', total);
        if (badge && r.save > 0) msg += ' ' + badge.textContent.replace(/\s+/g, ' ').trim();
        if (hint) msg += ' ' + hint;
        const live = this.querySelector('[data-live]');
        live.textContent = '';
        requestAnimationFrame(() => { live.textContent = msg; });
      }
    }

    setDisabled(busy) {
      // Yüklemede aria-disabled (odak butonda kalır) + this.busy koruması; kalıcı durumlarda gerçek disabled
      this.button.disabled = !this.mainAvailable || !this.count;
      this.button.setAttribute('aria-disabled', busy ? 'true' : 'false');
      const add = this.querySelector('[data-label-add]');
      const out = this.querySelector('[data-label-sold-out]');
      if (add) add.hidden = !this.mainAvailable;
      if (out) out.hidden = this.mainAvailable;
    }

    setMainVariant(v) {
      const main = this.querySelector('[data-row][data-main]');
      if (!main) return;
      const price = Number(v.price) || 0;
      // Liquid ile aynı: üstü çizili = güncel satış fiyatı (compare-at değil; o temanın fiyat bloğunda).
      const compare = price;
      Object.assign(main.dataset, { variantId: v.id, price, compare, bundle: price });
      // Sepet modunda compare-at'li ana ürün (exclude_discounted açıkken) ek ürünler gibi indirim dışı.
      const onSale = Number(v.compare_at_price) > price;
      main.toggleAttribute('data-ineligible', this.cartStyle && this.excludeDiscounted && onSale);
      const old = main.querySelector('[data-old]');
      old.querySelector('[data-money]').textContent = this.fmt(compare);
      // Fiyat/üstü çizili görünürlüğü update() → reprice() yazar (kademe ana ürüne de uygulanabilir).
      const idInput = this.form.querySelector('input[name="id"]');
      if (idInput) idInput.value = v.id;
      this.mainAvailable = v.available !== false;
      this.update(false);
    }

    showError(msg) {
      const box = this.querySelector('[data-error]');
      this.text('[data-error-text]', msg || '');
      box.hidden = !msg;
    }

    async submit(e) {
      e.preventDefault();
      if (this.busy || !this.count) return;
      const handle = this.dataset.mainHandle;
      const items = this.rows()
        .filter((r) => r.on)
        .map((r) => ({ id: r.id, quantity: 1, properties: { _tps_bundle: handle } }));
      const cart = document.querySelector('mini-cart');
      const drawer = cart && window.theme && theme.shopSettings && theme.shopSettings.cartDrawer
        && !document.body.classList.contains('template-cart');
      const body = { items };
      if (drawer) {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(body);
      const pub = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';

      this.busy = true;
      this.setDisabled(true);
      this.button.classList.add('loading');
      this.button.setAttribute('aria-busy', 'true');
      this.showError('');
      try {
        const url = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
        const res = await (await fetch(url, config)).json();
        if (res.status) {
          if (pub) publish(PUB_SUB_EVENTS.cartError, { source: 'tps-bundle-offer', errors: res.errors || res.description, message: res.message });
          this.showError(res.description || res.message || this.dataset.tError);
          // /cart/add atomik değil (doğrulanmadı): çekmeceyi sepetin gerçek durumuna eşitle
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        if (pub) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tps-bundle-offer', cart: res });
        document.dispatchEvent(new CustomEvent('tps:bundle:add', { detail: { items, main_handle: handle } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res } }));
        if (!drawer) {
          window.location = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
          return;
        }
        cart.setActiveElement(this.button);
        try {
          cart.renderContents(res);
        } catch (err) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (err) {
        console.error(err);
        this.showError(this.dataset.tError);
      } finally {
        this.busy = false;
        this.button.classList.remove('loading');
        this.button.removeAttribute('aria-busy');
        this.setDisabled(false);
      }
    }
  }

  customElements.define('tps-bundle-offer', TpsBundleOffer);
}
